import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {Partner} from "../partner.model";

export class PartnerDgSearchResults extends GenericDgSearchResults {
  public results: Partner[];

  constructor(total: number, results: Partner[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

